export const SERVICE_DETAILS_MAXLENGTH = {
  serviceIdMaxLength: '51',
  serviceNameMaxLength: '45',
  serviceDescMaxLength: '501',
  endPointMaxLength: '101',
  authNameMaxLength: '51',
  default: '0'
};

export const OPERATION_VERB = [
  { value: 0, name: 'POST' },
  { value: 1, name: 'GET' },
  { value: 2, name: 'PUT' },
  { value: 3, name: 'DELETE' },
  { value: 4, name: 'PATCH' },
  { value: 0, name: 'Query To Select' },
  { value: 1, name: 'Query To Insert/Update' },
  { value: 2, name: 'Stored Procedure To Query' },
  { value: 0, name: 'XML' },
  { value: 1, name: 'JSON' },
  { value: 2, name: 'EBCDIC' },
];

export const MQ_HEADER_KEY = [
  { value: 0, name: 'REPLY_QUEUE' },
  { value: 1, name: 'QUEUE_MANAGER' },
  { value: 2, name: 'CHANNEL' },
  { value: 3, name: 'TIMEOUT' },
  { value: 4, name: 'CUSTOM' }
];

export const SERVICE_TYPE_KEY = {
  REST: 'REST',
  EXTERNAL: 'External',
  SOAP: 'SOAP',
  DB2: 'DB2',
  MQ: 'MQ'
};

export const SERVICE_CATEGORY = 'Business';

export const SERVICE_TYPE_KEY_VALUE = {
  REST: '0',
  EXTERNAL: '1',
  SOAP: '2',
  DB2: '3',
  MQ: '4'
};
export const SERVICE_TYPE = [
  { value: 0, name: SERVICE_TYPE_KEY.REST },
  { value: 1, name: SERVICE_TYPE_KEY.EXTERNAL },
  { value: 2, name: SERVICE_TYPE_KEY.SOAP },
  { value: 3, name: SERVICE_TYPE_KEY.DB2 },
  { value: 4, name: SERVICE_TYPE_KEY.MQ }
];

export const specialCharacter = /^([a-zA-Z0-9-_])*$/;
export const nonSpaceCharacter = /^\S*$/;
export const invalidEventKeys = ['.', '-', '+', 'e'];
export const HEADER_KEY = ['REPLY_QUEUE', 'QUEUE_MANAGER', 'CHANNEL', 'TIMEOUT'];

export const AUTH_TYPE = [
  { value: 0, name: 'BASIC' },
  { value: 1, name: 'OAUTH' },
  { value: 2, name: 'APIKEY' }
];

export const AUTH_TYPE_NAME = {
  BASIC: 'BASIC',
  OAUTH: 'OAUTH',
  APIKEY: 'APIKEY'
};

export const AUTH_METHOD = [
  { value: 0, name: 'GET' },
  { value: 1, name: 'POST' },
];

export const urlRegx = "^(?:(?:https?|HTTP|ftp|FTP|HTTPS):\\/\\/)(?:(?:[a-zA-Z\\u00a1-\\uffff0-9-]+\\.)+[a-zA-Z\\u00a1-\\uffff]{2,}|(?:25[0-5]|2[0-4][0-9]|[01]?[0-9]{1,2})(?:\\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9]{1,2})){3})(?::\\d{1,5})?\\/?[a-zA-Z0-9\\-._~:/?#\\[\\]@!$&'()*+,;=%]*$";

export const variableRegex = '^[a-zA-Z_$][a-zA-Z0-9_$-]*$';

export const SERVICE_OPERATION_MAXLENGTH = {
  serviceOpsName: '51',
  opsURIMaxLength: '2001',
  queryPathParamMaxLength: '501',
  headerParamMaxLength: '501',
  capsuleButtonMaxlength: 25,
  timeOutMaxLength: 6
};

export const SERVICE_OPERATION_MAX_TIME_OUT = 60000;
export const nonSpaceCharacterRegex = /^\S*$/;
export const authUrlRegx = /^(http|https):(\/\/)[a-zA-Z0-9-_./?!:;'$#&={}[()+,%@~*]*$/;

export const SERVICE_FORM_PARAM = {
  serviceId: 'serviceId',
  serviceName: 'serviceName',
  endpoint: 'endpoint',
  authName: 'authName',
  serviceDescription: 'serviceDescription',
  userName: 'userName',
  passWord: 'password',
  authUrl: 'authUrl',
  paramKey: 'paramKey',
  paramValue: 'paramValue',
  headerXml: 'headerXml',
  namespace: 'namespace'
};
export const EGRESS_FORM_PARAM = {
  topicName: 'topicName',
  partitionId: 'partitionId',
  connectionString: 'connectionString',
};

export const SERVICE_OPS_FORM_PARAM = {
  serviceOperationName: 'serviceOperationName',
  operationURL: 'operationURL',
  operationVerb: 'operationVerb',
  queryParamKey: 'queryParamKey',
  headerParamKey: 'headerParamKey',
  queryParamValue: 'queryParamValue',
  headerParamValue: 'headerParamValue',
  requestAttributes: 'requestAttributes',
  responseAttributes: 'responseAttributes',
  retryErrorCode: 'retryErrorCode',
  retryCount: 'retryCount',
  timeOut: 'timeOut'
};

export const SERVICE_SORT_LABELS = {
  SERVICENAME: 'serviceName',
  STATUS: 'status',
  LASTMODIFIED: 'updatedTimestamp'
};

export const IMPORT_SUMMARY_CONST = {
  service: 'service',
  journey: 'journey',
  event: 'event'
};

export const AVRO_SCHEMA_THEMES = {
  scheme: 'monokai',
  author: 'wimer hazenberg (http://www.monokai.nl)',
  base00: '#272822',
  base01: '#383830',
  base02: '#49483e',
  base03: '#75715e',
  base04: '#a59f85',
  base05: '#f8f8f2',
  base06: '#f5f4f1',
  base07: '#f9f8f5',
  base08: '#f92672',
  base09: '#fd971f',
  base0A: '#f4bf75',
  base0B: '#77C57D',
  base0C: '#a1efe4',
  base0D: '#66d9ef',
  base0E: '#ae81ff',
  base0F: '#cc6633',
};

export const BASE_COLORS = {
  base0D_clr: '#252525',
  base0B_clr: '#1D6332',
  base09_clr: '#1D6332',
  base08_clr: '#1D6332',
};

export const FORM_SERVICE_TYPE = {
  REST: 'rest',
  EXTERNAL: 'external',
  SOAPSERVICE: 'soap',
  DB2: 'db2',
  MQ: 'mq'
};

export const FORM_AUTH_TYPE = {
  BASIC: 'basic',
  OAUTH: 'oauth',
  APIKEY: 'apikey',
};

export const associationEventType = {
  EGRESS: 'egress',
  INGRESS: 'ingress'
};

export const PASSWORD_ICON = {
  SHOW_PASSWORD: 'showPassword',
  HIDE_PASSWORD: 'hidePassword'
};

export const SERVICE_MODE = {
  EDIT: 'edit',
  VIEW: 'view'
};

export enum ServiceLabels {
  SERVICE_NAME = 'serviceName',
  SERVICE_STATUS = 'status',
  LAST_MODIFIED = 'updatedTimestamp',
  ACTION_BTN = 'actionBtn',
  CREATED_BY = 'createdBy',
  UPDATED_BY = 'updatedBy'
}

export const EXCEPTION_ACTION = {
  NOTIFY: 'Notify',
  COMPENSATE: 'Compensate',
  IGNORE: 'Ignore',
  COMPENSATE_AND_RECOVER: 'CompensateAndRecover'
};
